document.addEventListener('DOMContentLoaded', () => {
  let currentStep = 1;
  const steps = document.querySelectorAll('.bundle-step');
  const summary = document.getElementById('bundle-summary');
  const summaryList = document.getElementById('summary-list');
  const totalPriceEl = document.getElementById('bundle-total-price');
  const addToCartBtn = document.getElementById('add-to-cart');
  const selections = {};

  const optionsData = {
    'size-options': ['Twin/Twin XL', 'Full/Queen', 'King/Cal King'],
    'color-options': ['White', 'Oatmeal', 'Charcoal'],
    'material-options': ['Sateen', 'Percale'],
    'addon-options': ['Canvas Bag', 'Extra Sham Set']
  };

  const optionPrices = {
    size: { 'Twin/Twin XL': 199, 'Full/Queen': 249, 'King/Cal King': 279 },
    addons: { 'Canvas Bag': 20, 'Extra Sham Set': 40 }
  };

  Object.entries(optionsData).forEach(([id, values]) => {
    const container = document.getElementById(id);
    if (!container) return;
    values.forEach((val) => {
      const btn = document.createElement('button');
      btn.className = 'option-button';
      btn.textContent = val;
      btn.dataset.value = val;
      container.appendChild(btn);
    });
  });

  function showStep(step) {
    steps.forEach((s) => s.classList.add('hidden'));
    const stepDiv = document.querySelector(`.step-${step}`);
    if (stepDiv) stepDiv.classList.remove('hidden');
  }

  function goToNextStep() {
    currentStep++;
    if (currentStep <= steps.length) {
      showStep(currentStep);
    } else {
      renderSummary();
      summary.classList.remove('hidden');
      addToCartBtn.disabled = false;
    }
  }

  function renderSummary() {
    summaryList.innerHTML = '';
    let total = 0;

    Object.entries(selections).forEach(([key, value]) => {
      const li = document.createElement('li');
      li.textContent = `${capitalize(key)}: ${value}`;
      summaryList.appendChild(li);

      if (key === 'size' && optionPrices.size[value]) {
        total += optionPrices.size[value];
      }
      if (key === 'addons') {
        const addonsArray = value.split(', ');
        addonsArray.forEach(addon => {
          if (optionPrices.addons[addon]) total += optionPrices.addons[addon];
        });
      }
    });

    totalPriceEl.textContent = `$${total.toFixed(2)}`;
  }

  document.querySelectorAll('.options').forEach((group) => {
    group.addEventListener('click', (e) => {
      if (e.target.classList.contains('option-button')) {
        const groupId = group.id;
        const key = groupId.split('-')[0];

        group.querySelectorAll('.option-button').forEach(btn => btn.classList.remove('selected'));
        e.target.classList.add('selected');

        selections[key] = e.target.dataset.value;
        goToNextStep();
      }
    });
  });

  function capitalize(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
  }

  showStep(currentStep);
});
